module.exports = __webpack_public_path__ + "static/media/uae-home-banner.c8366e2f.png";